import React, { useState, useEffect } from 'react';
import { PubSub } from 'aws-amplify'
import { Container, Table, ToggleButtonGroup } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button, { ButtonProps } from '@mui/material/Button';
import  RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; 
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CardActions from '@mui/material/CardActions';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Typography from "@mui/material/Typography";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ToggleButton from '@mui/material/ToggleButton';
import moment from 'moment'
import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import { API } from '@aws-amplify/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const theme = createTheme({
  palette: {
      primary: {
          main: "#FF0000",
          contrastText: "#ffffff",
      },
      secondary: {
          main: "#808080",
          contrastText: "#ffffff",
      },
      success: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      error: {
        main: "#800000",
        contrastText: "#ffffff",
      },
      active: {
        main: "#800000",
        contrastText: "#ffffff",
      },
      asserted: {
        main: "#800000",
        contrastText: "#ffffff",
      },
      notasserted: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      changing: {
        main: "#0B6623",
        contrastText: "#ffffff",
      }
  },
});

export default function SwitchPoint(props) {
  const switch_info = props.switch_info.si;  
  const [message, setMessage] = useState("");
  const [relay1Icon,setRelay1Icon] = useState(relayAtRestIcon)
  const [relay2Icon,setRelay2Icon] = useState(relayAtRestIcon)
  const [relay1Color, setRelay1Color] = useState("secondary");
  const [relay2Color, setRelay2Color] = useState("secondary");
  const [gpio1Color, setGpio1Color] = useState("secondary");
  const [gpio2Color, setGpio2Color] = useState("secondary");
  const [modelOpen, setModalOpen] = React.useState(false);
  const [akaValue, setAkaValue] = useState(switch_info.switch_aka.S); 
  const [result, setResult] = useState("");
  const [response, setResponse] = useState('');
  const [formHidden, setformHidden] = useState(false);

  var subscribe_topic = "";
  var relayActivatedIcon = <TaskAltIcon />
  var relayAtRestIcon = < RadioButtonUncheckedIcon/>
  var myCounterNumber = props.switch_info.counter;

  const [formData, setFormData] = useState({
    switch_id: switch_info.switch_id.S ,
    switch_aka: switch_info.switch_aka.S
  });

  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))

 async function saveSwitchData(formDataGiven) {
  console.log('inside saveSwitchdata', formDataGiven);
  setResponse('Saving data. Please wait.');
  formDataGiven.switch_id = switch_info.switch_id.S;
  const apiName = 'apic48d2c9b'; 
  const path = '/config';
  const myInit = {
    body: formDataGiven,
    headers: {}, 
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  };
  return API.put(apiName, path, myInit);
 }

 const handleSaveSwitchDataSubmit = async (e) => {
  e.preventDefault();    
  console.log('would save this formdata ', formData);
  setformHidden(true);
  setResponse('Saving data now....');
  setFormData(formData);
  setformHidden(true);
  var post_save_response = await saveSwitchData(formData);
  setResponse(post_save_response.statusText);
  if (post_save_response.status === 200 ) {
    console.log('its 200');
    const date_string_now = new Date(post_save_response.data.timestamp);
    setResponse('Successfully saved on ' + date_string_now.toLocaleString('en-US') + " local time.");
    console.log(post_save_response);       
    await sleep(3000)
    setModalOpen(false);
    setResponse("");
  } 
  }

  async function sendIt(e) {
    console.log('sendit',e);
    var buttonname = e.target.id;


    console.log('buttonname',e.target.id);
    var simple_toggle_payload_string = '{"Output":"Relay","Relays":[{"relay":"Rel1", "state":2}, {"relay":"Rel2", "state":2}]}';
    var simple_payload_string = '{"Output":"Relay","Relays":[{"relay":"Rel1", "state":2}]}';
    var json_load = JSON.parse(simple_payload_string);

    if (buttonname.startsWith("on")) {
      json_load.Relays[0].state = 1;
    }

    if (buttonname.startsWith("off")) {
      json_load.Relays[0].state = 0;
    }

    if (buttonname.startsWith("tog")) {
      json_load.Relays[0].state = 2;
    }

    if (buttonname.endsWith("1")){
      json_load.Relays[0].relay = "Rel1";
    }

    if (buttonname.endsWith("2")){
      json_load.Relays[0].relay = "Rel2";
    }

    await PubSub.publish(subscribe_topic, json_load );
    console.log('pub awaited and done',json_load);
  }
  
  function iChanged()
  {
    console.log('i changed');
  }

  function messageShaping(message)
  {    
    var event_time;
    // clean up the relay1-i and adcin1-i properties    
    // console.log('msg shape',message);
    //var msg_data = JSON.stringify(message.value);
    var msg_data = JSON.stringify(message);    
    var msg_json = JSON.parse(msg_data.replaceAll("-i",""));

    if (msg_data === msg_json) {
      console.log("same value. code not needed")
    } 
    
    if (msg_json.hasOwnProperty('Output')) {
      console.log('Output.in.message',msg_json)
      var output_type = msg_json.Output;
      if (output_type === "Test") {
        console.log("returning ...output type is Test");
        var dataObjectCommand = {"Test": 'test'};
        return dataObjectCommand;
      }
      console.log('has output, not test, call it Command')
      var dataObjectCommandOutput = {Command: msg_json.Relays[0]};
      return dataObjectCommandOutput;
    } 

    if (msg_json.hasOwnProperty('IOTtime')) {
      event_time = Date.parse(msg_json.IOTtime);
    }

    if (msg_json.hasOwnProperty('Rel1')) {
      var dataObject =  {Relay1: msg_json.Rel1, Relay2: msg_json.Rel2, relayTime: event_time, IOTtime: event_time}; //Date.parse(md.relayTime));
      return dataObject;
    }

    if (msg_json.hasOwnProperty('ADC1')) {
      var dataObjectAd = {adVolts: msg_json.ADCin1, adTime: event_time, IOTtime: event_time};
      return dataObjectAd;
    }

    if (msg_json.hasOwnProperty('GPIO1')) {
      var dataObjectGpio= {GPIO1: msg_json.GPIO1, GPIO2: msg_json.GPIO2, gpioTime: msg_json.gpioTime, IOTtime: event_time};
      return dataObjectGpio;
    }

    if (msg_json.hasOwnProperty('Test')) {
      var dataObjectTest= {Test: msg_json.val0, testTime: msg_json.IOTtime, IOTtime: event_time};
      return dataObjectTest;
    }
    //shouldnt get here
    messageShaping =  {NotExpected: msg_json};
  }

  function handleModalOpen() {
    setModalOpen(true);
  }

  function handleModalClose() {
    setModalOpen(false);
  }

  function modalCancel() {
    setModalOpen(false);
  }

  function handleModalEntry(e) {  
    console.log(' change in id as value ', e.target.id, e.target.value);
    setFormData({"switch_aka": e.target.value});
    setResult('');
  } 

  useEffect(() => {
    subscribe_topic = "policy/relays/" + switch_info.switch_id.S;
    console.log('subscribing to', subscribe_topic);
    const sub1 = PubSub.subscribe(subscribe_topic).subscribe({
        next: (data) => {
          console.log('>>>--next:data-->', switch_info.topic, data) ;     
          setMessage(JSON.stringify(data.value));
          var m = messageShaping(data.value);
          console.log(m);
          if (m?.Relay1===1) setRelay1Color("success");
          if (m?.Relay1===0) setRelay1Color("error");
          if (m?.Relay2===1) setRelay2Color("success");
          if (m?.Relay2===0) setRelay2Color("error");
          if (m?.GPIO1==='Off') setGpio1Color("success");
          if (m?.GPIO1==='On') setGpio1Color("error");
          if (m?.GPIO2==='Off') setGpio2Color("success");
          if (m?.GPIO2==='On') setGpio2Color("error");
        },
        error: (error) => console.error(error),
        complete: () => console.log('Complete done')
    });    
    return () => sub1.unsubscribe();
  }, [] )
  return (
    <ThemeProvider theme={theme}>
      <Modal
            open={modelOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                update switch attributes
              </Typography>
              <div id="formgoeshere" >

              <form onSubmit={handleSaveSwitchDataSubmit}> 
                <label>Also Known As</label> 
                <input   
                    type = "text"                  
                    id="aka"
                    value={formData.switch_aka}
                    onChange={handleModalEntry} 
                    required 
                />    

                <button id="saveAka" type="submit" >Save</button>
            </form> 
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <Button
                  style={{ width: 20, height: 20, padding: 20 }}
                  onClick={() => modalCancel()}
                >
                  CANCEL{" "}
              </Button>               
              </Typography>
            <div> 
                <h4>{result}</h4> 
                {response && <p>{response}</p>}
            </div> 
            </Box>
      </Modal>
      
      <Card sx={{ maxWidth: 480, backgroundColor: "lightgrey"}} variant="outlined" >
        <CardHeader
          action={
            <IconButton aria-label="settings" onClick={handleModalOpen}>
              <MoreVertIcon />
            </IconButton>
          }
          title =  {switch_info.switch_aka.S}
          subheader = {switch_info.switch_id.S}
          />
        <CardContent>
          <Typography variant="h6" component="div">
          </Typography>
          <ButtonGroup align="center">
            <Button
              id="relay1_state_button"
              variant="contained"
              endIcon={relay1Icon}
              color={relay1Color}
              size="small"
            >
              RELAY 1
            </Button>
            <Button
              id="relay2_state_button"
              variant="contained"
              endIcon={relay2Icon}
              color={relay2Color}
              size="small"
            >
              RELAY 2
            </Button>
            <Button
                id="gpio1_state_button"
                variant="contained"
                endIcon={<RadioButtonUncheckedIcon />}
                color={gpio1Color}
                size="small"
              >
                GPIO 1
            </Button>
            <Button
                id="gpio2state_button"
                variant="contained"
                endIcon={<RadioButtonUncheckedIcon />}
                color={gpio2Color}
                size="small"
            >
            GPIO 2
            </Button>
            <Button
              id="heartbeat"                  
              endIcon={<FavoriteBorderIcon />}
              size="small">
            </Button>
          </ButtonGroup>

          <Typography variant="body2" component="div" >
          {message}
          </Typography>
        </CardContent>

  <CardActions>
  <ButtonGroup align="left">

    <Button id="off1" 
      size="small"
      onClick={sendIt}  
      color = "notasserted"
      startIcon={<RadioButtonUnchecked  fontSize="small" color="notasserted"/>}
    >
    Off
    </Button> 

    <Button id="on1" 
      size="small"
      onClick={sendIt}  
      startIcon={<RadioButtonCheckedIcon fontSize="small"  />}
    >On
    </Button>
    <Button id="toggle1" onClick={sendIt}
     startIcon={<ChangeCircleIcon fontSize="small" color="changing" />}
    >
    Tog</Button>
  </ButtonGroup>

  <ButtonGroup align="right">
        <Button id="off2" 
          onClick={sendIt}
          color="notasserted">
              Off</Button> 
          <Button id="on2" onClick={sendIt} color="asserted">On</Button>
          <Button id="toggle2" onClick={sendIt} color="changing">Tog</Button>
        </ButtonGroup>
      </CardActions> 
      </Card>
    </ThemeProvider>
  )
}

//https://github.com/aws-amplify/amplify-js/issues/9882